import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TruckLocationService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('TruckLocation');
	}

	loadForTruckAndDate(id: System.Guid, date: Date): Observable<TooBig4Car.Logic.TruckLocation[]> {
		return this.myBaseService.loadAll(this.url + '/' + (id || '') + '?date=' + this.myBaseService.configData.getDateStr(date));
	}
}
